export class SpSadtSerialProcedure {
    public idSpSadtSerialProcedure : number;
    public idSpSadtGuide : number;
    public executionDate : Date;
    public datetimeInclusion : Date;
}